import axios from 'axios';
import componentConstants from '../messages/componentConstants';
import properties from '../properties';
import recommendationsInternalScreenPopUpMessages from '../messages/recommendationsInternalScreenPopUpMessages';

export const base64toByteArrayConverter = (base64: string) => {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return byteArray;
};

export const downloadPdf = (
  reportName: string,
  body: any,
  handleOpenSnackbar?: any,
  type?: 'open',
) => {
  const token = JSON.parse(localStorage.getItem('token-storage') as string)
    ?.access_token;
  const messages = componentConstants.ORGANISMS.REPORTS_MODAL.SNACKBAR_MESSAGES;
  axios
    .post(
      properties.aiqBaseUrl +
        properties.downloadReports +
        `?name=${reportName}`,
      body,
      {
        headers: {
          Authorization: token,
        },
      },
    )
    .then((res) => {
      if (res) {
        const byteArray = base64toByteArrayConverter(res.data?.data);
        const file = new Blob([byteArray], { type: 'application/pdf;base64' });
        const fileURL = URL.createObjectURL(file);
        if (type === 'open') {
          window.open(fileURL, '_blank');
          handleOpenSnackbar(messages.OPEN_SUCCESS, 'success', 5000);
        }
      }
    })
    .catch((error) => {
      handleOpenSnackbar(
        error.response?.data?.error ?? messages.API_ERROR,
        'error',
        5000,
      );
    });
};

export const downloadCSV = (
  downloadAnchorRef: React.RefObject<HTMLAnchorElement | null>,
  url: string,
  requestBody: any,
  fileName: string,
) => {
  const token = JSON.parse(localStorage.getItem('token-storage') as string)
    ?.access_token;
  axios
    .post(url, requestBody, {
      headers: {
        Authorization: token,
      },
    })
    .then((res) => {
      if (res) {
        const file = new Blob([res.data], { type: 'text/csv' });
        const ref = downloadAnchorRef;
        ref!.current!.href = URL.createObjectURL(file);
        ref!.current!.download = fileName;
        ref!.current!.click();
      }
    });
};

export const handleDownloadCSV = async (
  url: string,
  requestBody: any,
  fileName: string,
  handleOpenSnackBar: any,
) => {
  const token = JSON.parse(localStorage.getItem('token-storage') as string)
    ?.access_token;
  axios
    .post(url, requestBody, {
      headers: {
        Authorization: token,
      },
    })
    .then((res) => {
      if (res) {
        const file = new Blob([res.data], { type: 'text/csv' });
        const fileURL = URL.createObjectURL(file);

        const link = document.createElement('a');
        link.href = fileURL;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
      }
    });
  handleOpenSnackBar(
    recommendationsInternalScreenPopUpMessages.downloadCSVMessage,
    'info',
    5000,
  );
};

export const handleDownloadTopProcedureCSV = async (
  url: string,
  requestBody: any,
  fileName: string,
  handleOpenSnackBar: any,
  isCostView: boolean = true,
) => {
  const token = JSON.parse(localStorage.getItem('token-storage') as string)
    ?.access_token;

  try {
    const res = await axios.post(url, requestBody, {
      headers: {
        Authorization: token,
      },
    });

    const procedures = res?.data?.data?.procedures;

    if (!Array.isArray(procedures) || procedures.length === 0) {
      console.error('No procedures data found');
      return;
    }

    // ✅ Dynamic headers based on view type
    const headers = isCostView
      ? ['Procedure', 'Total Cost', 'Plan Paid', 'Member Paid']
      : ['Procedure', 'Total Cost', 'Claimants', 'Claims'];

    // ✅ Dynamic rows based on view type
    const rows = procedures.map((item: any) => {
      if (isCostView) {
        // Cost view
        return [
          `"${String(item.procedure ?? '').replace(/"/g, '""')}"`,
          `"${String(item.totalCost ?? '').replace(/"/g, '""')}"`,
          `"${String(item.totalPlanPaid ?? '').replace(/"/g, '""')}"`,
          `"${String(item.totalMemberPaid ?? '').replace(/"/g, '""')}"`,
        ].join(',');
      } else {
        // Volume view
        return [
          `"${String(item.procedure ?? '').replace(/"/g, '""')}"`,
          `"${String(item.totalCost ?? '').replace(/"/g, '""')}"`,
          `"${String(item.claimants ?? '').replace(/"/g, '""')}"`,
          `"${String(item.claims ?? '').replace(/"/g, '""')}"`,
        ].join(',');
      }
    });

    const csvContent = [headers.join(','), ...rows].join('\n');

    const file = new Blob([csvContent], {
      type: 'text/csv;charset=utf-8;',
    });

    const fileURL = URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = fileURL;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();

    handleOpenSnackBar(
      recommendationsInternalScreenPopUpMessages.downloadCSVMessage,
      'info',
      5000,
    );
  } catch (error) {
    console.error('CSV download failed', error);
  }
};

//Commenting the changes as it is needed in future.

// export const downloadExcel = (
//   downloadAnchorRef: React.RefObject<HTMLAnchorElement>,
//   url: string,
//   fileName: string,
// ) => {
//   const token = JSON.parse(localStorage.getItem('token-storage') as string)
//     ?.access_token;
//   axios
//     .get(url, {
//       headers: {
//         Authorization: token,
//       },
//     })
//     .then((res) => {
//       if (res) {
//         const file = new Blob([res.data], {
//           type:
//             'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//         });
//         const ref = downloadAnchorRef;
//         ref!.current!.href = URL.createObjectURL(file);
//         ref!.current!.download = fileName;
//         ref!.current!.click();
//       }
//     });
// };

export const downloadMultipleReports = (
  reportName: string,
  body: any,
  handleOpenSnackbar: any,
  type: 'open' | 'download',
) => {
  const messages = componentConstants.ORGANISMS.REPORTS_MODAL.SNACKBAR_MESSAGES;
  const token = JSON.parse(localStorage.getItem('token-storage') as string)
    ?.access_token;
  axios
    .post(properties.aiqBaseUrl + properties.downloadMultipleReports, body, {
      headers: {
        Authorization: token,
      },
    })
    .then((res) => {
      if (res.status === 200) {
        if (res) {
          const byteArray = base64toByteArrayConverter(res.data?.data);
          const file = new Blob([byteArray], {
            type: 'application/pdf;base64',
          });
          const fileURL = URL.createObjectURL(file);

          if (type === 'download') {
            const link = document.createElement('a');
            link.href = fileURL;
            link.setAttribute('download', reportName);
            document.body.appendChild(link);
            link.click();
            handleOpenSnackbar(messages.DONWLOAD_SUCCESS, 'success', 5000);
          }
          if (type === 'open') {
            window.open(fileURL, '_blank');
            handleOpenSnackbar(messages.OPEN_SUCCESS, 'success', 5000);
          }
        }
      }
    })
    .catch((error) => {
      handleOpenSnackbar(
        error.response?.data?.error ?? messages.API_ERROR,
        'error',
        5000,
      );
    });
};

export const downloadPPThelper = async (body: any, handleOpenSnackbar: any) => {
  const messages = componentConstants.ORGANISMS.REPORTS_MODAL.SNACKBAR_MESSAGES;
  const token = JSON.parse(localStorage.getItem('token-storage') as string)
    ?.access_token;

  await axios
    .post(properties.aiqBaseUrl + properties.quarterlyReport, body, {
      headers: {
        Authorization: token,
      },
    })
    .then((response: any) => {
      const binary = atob(response?.data?.data?.base64);
      const array = [];
      for (let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
      }
      const blob = response?.data?.data?.isPpt
        ? new Blob([new Uint8Array(array)], {
            type:
              'application/vnd.openxmlformats-officedocument.presentationml.presentation',
          })
        : new Blob([new Uint8Array(array)], {
            type: 'application/pdf',
          });

      // Create a URL for the blob
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = response?.data?.data?.fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    })
    .catch((error: any) => {
      handleOpenSnackbar(
        error.response?.data?.error ?? messages.API_ERROR,
        'error',
        5000,
      );
    });
};
